(function($, window) {

	/**
	 * Safari needs url for SVG clip-path to be absolute.
	 */

	$(document).ready(function () {
		init();
		$('body').on('cms.ready', init); // re-init after cms is ready
	});

	function init() {
		var localClipPaths = $('.sectionImageHero [clip-path^="url(#"]');

		localClipPaths.each(function(i, elm) {
			var $elm = $(elm);
			var str = $elm.attr('clip-path').replace(/url\(#(.*)\)/ig, 'url(' + window.location.href + '#$1)');
			$elm.attr('clip-path', str);
		});
	}

})(jQuery, window);